"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactIntl = require("react-intl");
const errors = (0, _reactIntl.defineMessages)({
  requiredField: {
    id: "forms.errors.is_required"
  },
  accountExists: {
    id: "account.login_already_exists"
  },
  shortPassword: {
    id: "account.password_too_short"
  },
  weakPassword: {
    id: "account.password_too_simple"
  },
  invalidEmail: {
    id: "account.wrong_format_email"
  },
  loginFailed: {
    id: "account.login_failed"
  },
  notVerified: {
    id: "account.user_is_not_verified"
  },
  blockedTemporarily: {
    id: "account.user_temporarily_blocked_from_login"
  },
  passwordMismatch: {
    id: "account.password_confirm_not_matching"
  },
  wrongIATACode: {
    id: "forms.enter_iata_code"
  },
  incorrectBidIATAInput: {
    id: "account.my_booking_login_incorrect"
  },
  invalidDate: {
    id: "forms.errors.invalid_date"
  },
  general: {
    id: "common.api_error"
  }
});
var _default = errors;
exports.default = _default;